module.exports = {"210802001":"八田地街道","210802002":"建丰街道","210802003":"建设街道","210802004":"跃进街道","210802005":"东风街道","210802006":"新兴街道","210802007":"新建街道","210802401":"营口高新区站前区工业园"}


//////////////////
// WEBPACK FOOTER
// ./src/town/210802.json
// module id = 510
// module chunks = 0